import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../services/auth.service';
import { MatButtonModule } from '@angular/material/button';
import { BehaviorSubject, filter } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth, User, authState } from '@angular/fire/auth';
import { AnalyticsService } from '../../services/analytics.service';

declare var particlesJS: any;

@Component({
  selector: 'app-signin',
  standalone: true,
  imports: [CommonModule, MatButtonModule, ReactiveFormsModule, FormsModule, MatFormFieldModule, MatInputModule, MatTooltipModule],
  templateUrl: './signin.component.html',
  styleUrl: './signin.component.scss'
})
export class SigninComponent {
  fb = inject(FormBuilder)
  router = inject(Router)
  analytics = inject(AnalyticsService)
  private route = inject(ActivatedRoute);
  private firebaseAuth = inject(Auth);
  private destroyRef = inject(DestroyRef);




  loginForm: FormGroup;
  constructor(private auth: AuthService) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
    particlesJS.load('particles-js', 'assets/particles.json', function () { });
  }

  // Post-login redirect. It lives here and not in authRedirectGuard because a
  // guard reacts to navigations, not to auth state changes: by the time the user
  // submits their credentials they are already on /auth and the guard is done.
  // Covers all three sign-in methods (email, Google, Microsoft) alike, and the
  // subscription dies with the component.
  ngOnInit(): void {
    authState(this.firebaseAuth).pipe(
      // No take(1): if an unauthorized user is rejected and retries with another
      // account without reloading, the subscription is still alive to redirect.
      filter((user): user is User => !!user),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(async (user) => {
      const isAuthorized = await this.auth.checkUserAuthorization(user.uid);
      if (!isAuthorized) {
        this.auth.showUnauthorizedMessage();
        await this.auth.signOut();
        return;
      }
      const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
      this.router.navigateByUrl(
        returnUrl && !returnUrl.startsWith('/auth') ? returnUrl : '/boards'
      );
    });
  }
  onSubmit(): void {
    if (this.loginForm.valid) {
      const { email, password } = this.loginForm.value;
      this.analytics.sendCustomEvent(
        'login', { method: 'email' }
      )
      this.auth.signinWithEmailAndPass(email, password)
    }
  }


  hide = true;

  public loader$ = new BehaviorSubject<any>({ state: false, error: false });

  public formLogin = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email]),
    password: new FormControl("", [
      Validators.required,
      Validators.minLength(2),
      // Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$'),
      Validators.maxLength(20),
    ]),
  });






  signinWithGoogle() {
    console.log('signinWithGoogle')
    this.analytics.sendCustomEvent(
      'login', { method: 'google' }
    )


    this.auth.signInGoogle()
  }

  signinWithMicrosoft() {
    this.auth.signInMicrosoft()
  }

  signOut() {
    console.log('signOut')
    this.auth.signOut()
  }


}
